module.exports = __webpack_public_path__ + "static/media/IsolatedShower.73586dcf.svg";